import { render } from "./RenMY.vue?vue&type=template&id=68aecec6&scoped=true"
import script from "./RenMY.vue?vue&type=script&lang=js"
export * from "./RenMY.vue?vue&type=script&lang=js"

import "./RenMY.vue?vue&type=style&index=0&id=68aecec6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68aecec6"]])

export default __exports__